import Vue from 'vue';

import './assets/scss/main.scss';

import './plugins';
import './initializers';

import './registerServiceWorker';

import i18n from './plugins/vue-i18n';
import oauth from './plugins/oauth';

import App from './App.vue';
import router from './router';

import { DEVTOOLS, PRODUCTION_TIP } from './config';

Vue.config.devtools = DEVTOOLS;
Vue.config.productionTip = PRODUCTION_TIP;

new Vue({
  i18n,
  oauth,
  router,
  render: h => h(App),
}).$mount('#app');
